<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your desired loan amount
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-check-circle text-success text-7xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #title>
                <span data-testid="leadgen-partner-title">You've been matched with one of our lending partners.</span>
            </template>

            <template #text>
                <p data-testid="leadgen-partner-text">
                    We couldn't connect your bank for an instant decision, so we shared your application with a
                    lending partner who can review it.
                </p>

                <div v-if="partnerUrl" class="flex justify-center mt-10">
                    <a
                        :href="partnerUrl"
                        rel="noopener"
                        data-testid="leadgen-partner-continue"
                        class="bg-[#EC9D47] p-5 text-white rounded flex items-center justify-center hover:bg-[#DB8C36]"
                    >
                        Continue with our partner
                    </a>
                </div>

                <p v-else data-testid="leadgen-partner-contact">
                    Our partner will contact you directly. If you have any questions please
                    <a href="/contact" target="_blank" class="text-black">contact us.</a>
                </p>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    props: ['loan', 'partnerUrl'],

    data() {
        return {
            gTagPageName: 'loan-leadgen-partner',
        }
    },

    created() {
        this.gTagEvent('loan-leadgen-partner', {
            event_category: 'onboarding',
            event_label: this.partnerUrl ? 'loan-leadgen-partner-link' : 'loan-leadgen-partner-contact',
        });
    }
}
</script>
